<div class="quoter-layout">
    <org-layout-quoter-header></org-layout-quoter-header>
    <router-outlet></router-outlet>
    <org-layout-footer></org-layout-footer>
</div>